import dayjs from 'dayjs';
import { getDateFormatted } from './helpers/common.helper';
import moment from 'moment';

export const parseDate = (date: moment.MomentInput) =>
  moment(date).isValid() ? moment(date) : null;

export const formatDateColumn = (
  record: Parameters<typeof dayjs>[0],
  showTime = true
) =>
  record
    ? dayjs(record).format(
        `${getDateFormatted()}${showTime ? ' HH:mm:ss' : ''}`
      )
    : '';

export const formatTimeColumn = (record: Parameters<typeof dayjs>[0]) =>
  record ? dayjs(record).format('HH:mm') : '';

export const parseTime = (time: string) => time ? dayjs(time, 'HH:mm') : null;
export const formatTime = (time: dayjs.Dayjs | null) => time ? time.format('HH:mm') : null;
